import styled from 'styled-components';
import { AddSharp } from '@mui/icons-material';

const AddIndicator = styled(AddSharp)`
    color: ${({ theme }) => theme.gray.label};
`;

export default AddIndicator;
